import React, { Component } from 'react';
import '../App.css';

class GoogleTrends extends Component {
  render() {
    const isFForIE = !!navigator.userAgent.match(/firefox|gecko/i);
    if (Object.keys(this.props.content).length !== 0) {
      return (
        <div id='iframeContainer'>
          <iframe id='iframeTrends' scrolling='no'
            src={this.props.content[0].contentTrends} style={(isFForIE && {height: "375px"}) || {}}></iframe>
          <iframe id='iframeGeo' scrolling='no'
            src={this.props.content[0].contentGeo} style={(isFForIE && {height: "375px"}) || {}}></iframe>
        </div>
      );
    } else {
      return (
        <div>
        <p>Loading...</p>
        </div>
      );
    }
  }
}

export default GoogleTrends;



// WEBPACK FOOTER //
// ./client/src/Engines/GoogleTrends.js